import cxs from 'cxs';
import { MEDIA_QUERIES, FONT_SIZES, COLOURS } from '../../../common/styles/vars';

export const CONTENT = cxs({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  padding: '45px',

  '> .first-button': {
    marginRight: '10px'
  },

  [MEDIA_QUERIES.small]: {
    paddingLeft: '0px',
    paddingRight: '0px',
    paddingBottom: '10px'
  }
});

export const FOOTER = (alignActionBtnsToEnd = false) => cxs({
  alignItems: 'center',
  display: 'flex',
  fontSize: FONT_SIZES.small,
  justifyContent: alignActionBtnsToEnd ? 'flex-end' : 'flex-start',
  minHeight: '34px',
  flexWrap: 'wrap',
  marginTop: '20px',

  '> .first-button': {
    marginRight: '10px'
  }
});

export const HEADER = cxs({
  display: 'flex',
  marginBottom: '20px',
  alignItems: 'center'
});

export const ICON_WRAPPER = cxs({
  borderRadius: '17.5px',
  width: '35px',
  height: '35px',
  background: COLOURS.cyan.jungleGreen.monkey,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '15px'
});

export const HEADER_TEXT = cxs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
});

export const WRAPPER = {
  padding: '25px',

  [MEDIA_QUERIES.small]: {
    padding: '25px'
  },

  ' .modal-close-icon': {
    top: '30px'
  }
};